import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityProject } from "../../entity/EntityProject";

export class DtoProjectsGetReq extends EntityProject {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (
      !commonRegx.isMatch(
        this.c_project_number!.toString(),
        "^\\d+$",
        commonRegx._stdOption
      )
    ) {
      res.push("type error");
    }

    return res;
  }
}
